import { useEffect, useState }     from "react";
import useSWR                      from "swr";
import { getNotificationCount }    from "_services/api/user";
import Presentation                from "./presentation";
import { Router, useRouter }       from "next/router";
import { isPageRoute }             from "_common/utils";
import { notificationQRPopupAtom } from "_jotai/notifications";
import { useAtom }                 from "jotai";

const fetcher = async () => {
	const res = await getNotificationCount ();

	return res.count;
};

const component = () => {

	const router = useRouter ();

	const isNotificationsPage = isPageRoute ( { router, page: "notifications" } );

	const [ open, setOpen ]             = useState ( false );
	const [ countState, setCountState ] = useState ( null );

	const { data: notificationCount, error: notificationError } = useSWR ( "notification-count", fetcher,
		{
			fallbackData: 0
			// revalidateIfStale     : true,
			// revalidateOnFocus     : true,
			// revalidateOnReconnect : true
		} );

	const [ notificationQRPopup ] = useAtom ( notificationQRPopupAtom );

	// close notification tab when page is changing
	useEffect ( () => {
		Router.events.on ( "routeChangeComplete", handleClose );

		return () => {
			Router.events.off ( "routeChangeStart", handleClose );
		  };

	}, [] );

	useEffect ( () => {
		if ( open )
			return;

		setCountState ( notificationCount );
	}, [ notificationCount ] );

	const [ anchorEl, setAnchorEl ] = useState ( null );

	const handleClick = event => {
		if ( isNotificationsPage )
			return;
		setAnchorEl ( event.currentTarget );
		setOpen ( true );
		setCountState ( null );
	};

	const handleClose = () => {
		setAnchorEl ( null );
		setOpen ( false );
	};

	// if ( notificationError ) {
	// return null;
	// }

	return (
		<Presentation
			anchorEl            = { anchorEl }
			handleClick         = { handleClick }
			handleClose         = { handleClose }
			isNotificationsPage = { isNotificationsPage }
			notificationCount   = { countState }
			notificationQRPopup = { notificationQRPopup }
			open                = { open }
		/>
	);
};

export default component;
